import type { SummaryRow } from "./signup.model.ts";

type Props = {
  name: string;
  email: string;
  rows: SummaryRow[];
  bookCall: boolean;
  error: string | null;
  busy: boolean;
  onEnter: () => void;
};

export function SignupSummary({
  name,
  email,
  rows,
  bookCall,
  error,
  busy,
  onEnter,
}: Props) {
  return (
    <div className="signup__done">
      <p className="signup__tick" aria-hidden="true">
        ✓
      </p>
      <h2 className="auth__heading signup__done-heading">Account created</h2>
      <p className="signup__done-body">
        Welcome to ONDO, <strong>{name}</strong>. Your account is set up and your
        email address is verified.
      </p>

      <dl className="signup__summary">
        {rows.map((row) => (
          <div className="signup__summary-row" key={row.label}>
            <dt className="signup__summary-label">{row.label}</dt>
            <dd className="signup__summary-value">{row.value}</dd>
          </div>
        ))}
      </dl>

      {bookCall && (
        <p className="signup__callout-note">
          📅 An onboarding call invite will be sent to <strong>{email}</strong>{" "}
          within 24 hours.
        </p>
      )}

      {error && (
        <p className="signup__error" role="alert">
          {error}
        </p>
      )}

      <button
        type="button"
        className="signup__submit"
        disabled={busy}
        onClick={onEnter}
      >
        {busy ? "Entering ONDO…" : "Enter ONDO →"}
      </button>
    </div>
  );
}
